import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { Button, Row, Col, Form, Input, PageHeader, Radio } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { useNavigate, useLocation } from "react-router-dom";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import {
  currency_List,lengthUnit,weightUnit 
  } from "../../../Utils/Constant/MeasurementUnitList.jsx";
// import { paperMachineListData } from "../../../Services/machineServices";

const exportMachineData = [
  { label: "CSV", value: "CSV" },
  { label: "PDF", value: "PDF" },
];

const headers = [
  { label: "MACHINE CODE", key: "code" },
  { label: "MACHINE NAME", key: "name" },
  { label: "MIN. GSM", key: "minimum_gsm" },
  { label: "MAX. GSM", key: "maximum_gsm" },
  { label: "MIN. DECKLE WIDTH", key: "minimum_width" },
  { label: "MAX. DECKLE WIDTH", key: "maximum_width" },
  // { label: "LEFT TRIM (CM)", key: "left" },
  // { label: "RIGHT TRIM (CM)", key: "right" },
  // { label: "EFF. DECKLE WIDTH (CM)", key: "effective" },
  { label: "EFF. PRODUCTION CAPACITY", key: "production_capacity" },
  { label: "ORDER TYPES", key: "order_type" },
  // { label: "MAX. CUTTERS", key: "maximum_cutters" },
  // { label: "MAX. ALLOWED TRIM LOSS", key: "wastage" },
  { label: "STATUS", key: "status" },
  { label: "REMARKS", key: "remarks" },
];

const ExportMachine = (props) => {
  const [exportMachineDetail, setexportMachineDetail] = useState(
    exportMachineData[1].value
  );
  const location = useLocation();
  const [parentRecords, setParentRecords] = useState(location.state?.machineRecords);
  const [machineRecords, setMachineRecords] = useState([]);
  const [fileName, setFileName] = useState(location.state?.fileName?  location.state?.fileName : "Machine_Records")
  const history = useNavigate();

  useEffect(() => {
    if(!location?.state?.onBack){
      fetchMachineRecords();
    } else{
      setMachineRecords(parentRecords);
    }
  }, [parentRecords]);

  useEffect(()=> {
    if(machineRecords?.length){
      if (!location?.state?.onBack) {
        if(exportMachineData == "PDF")
        {
          history("../machine-records/export-machine/pdf", {
                state: {
                    body: location?.state?.body,
                    machineRecords: machineRecords,
                    rootPage: location?.state?.rootPage,
                    fileNameForPDF: fileName,
                    exportMachineDetail: exportMachineDetail
                  },
          });
        }
        else
        {
          exportHandler();
        }
      }
  }
  },[machineRecords]);

  const fetchMachineRecords = async () => {
    try {
      const formattedRecords = parentRecords?.map((machine) => {
        return {
          code: machine.code,
          name: machine.name,
          minimum_gsm: machine.minimum_gsm,
          maximum_gsm: machine.maximum_gsm,
          gsm_range: `${machine.minimum_gsm} - ${machine.maximum_gsm}`,
          minimum_width: machine.minimum_width + ' ' + machine.units.minimum_width,
          maximum_width: machine.maximum_width + ' ' + machine.units.maximum_width,
          width_range: `${machine.minimum_width} - ${machine.maximum_width} ${lengthUnit[ machine.units.maximum_width].displayName}`,
          production_capacity: machine.production_capacity + ' ' + weightUnit[machine.units.production_capacity].displayName,
          maximum_cutters: machine.maximum_cutters,
          maximum_waste: machine.maximum_waste,
          order_type:
            machine.order_type === "both"
              ? "Both"
              : machine.order_type === "reel"
              ? "Reel"
              : machine.order_type === "sheet"
              ? "Sheet"
              : null,
          status: machine.status === "active" ? "Active" : "Disabled",
          left: machine.left_edge_trim,
          right: machine.right_edge_trim,
          effective: machine.effective_deckle_length,
          wastage: machine.maximum_waste,
          remarks: machine.remarks,
          units : machine.units
        };
      });
      // console.log("Records", records, formattedRecords);
      setMachineRecords(formattedRecords);
      setexportMachineDetail(location?.state?.exportMachineDetail);
    } catch (err) {
      console.log("Error in fetching machine records", err);
    }
  };

  const exportStatusChange = (e) => {
    setexportMachineDetail(e.target.value);
  };
  const exportHandler = async() => {
    if(machineRecords?.length){
      if(exportMachineDetail === "CSV"){
        try{
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet('Machine Records');

          worksheet.columns = headers.map((header)=>({
            header: header.label,
            key: header.key,
          }))

          const headRow = worksheet.getRow(1);

          headRow.eachCell((cell)=>{
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: {
                argb: "f3f4f6"
              }
            }
            cell.font = {
              bold: true,
            }
          })

          machineRecords?.forEach((record)=>{
            const row = worksheet.addRow(record);
          })

          worksheet.columns.forEach((column)=>{
            let maxLength = 10;
            column.eachCell((cell)=>{
              let value = cell?.value?.toString() || "";
              maxLength = Math.max(maxLength,value?.length);
            })
            column.width = maxLength>50?50:maxLength+2;
          })

          const buffer = await workbook.xlsx.writeBuffer();
          saveAs(new Blob([buffer]),`${fileName}.xlsx`)
        }
        catch(e)
        {
          console.log(e);
        }      
      } else {
        history("../machine-records/export-machine/pdf", {
                state: {
                    body: location?.state?.body,
                    machineRecords: machineRecords,
                    rootPage: location?.state?.rootPage,
                    fileNameForPDF: fileName,
                    exportMachineDetail: exportMachineDetail
                  },
          });
      }
    } else{
      history("../machine-records/preparing-export-machine", {
        state: {
          body: location?.state?.body,
          rootPage: location?.state?.rootPage,
          fileName: fileName,
          headers: headers,
          exportMachineDetail: exportMachineDetail
        },
      });
    }
  };
  return (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => history("../machine-records")}
          title="Export machine records"
          extra={[
            <Button
              key="1"
              className="themeBtn noBg"
              onClick={() => history("../machine-records")}
            >
              <Iconmoon icon="wrong" size={14} color="#EA655B" />
              Cancel
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form name="basic" autoComplete="off" className="haberLogin">
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Select Options</h2>
                    <p>
                      Here you can select options to customize data that will be
                      downloaded
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Data Format</label>
                        <p>Select a format to download data</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Radio.Group
                          options={exportMachineData}
                          onChange={exportStatusChange}
                          value={exportMachineDetail? exportMachineDetail : "PDF"}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="buttonRight" style={{ marginTop: "20px" }}>
                <Form.Item>
                  {!exportMachineDetail || exportMachineDetail === "PDF" ? (
                    <Button
                      onClick={() => exportHandler()}
                      className="themeBtn"
                    >
                      Preview &#38; Download Records
                    </Button>
                  ) : (
                    <Button className="themeBtn csv"
                          onClick={() => exportHandler()}>
                            Download Machine Records
                    </Button>
                  )}
                </Form.Item>
              </div>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
    </RightLayoutContainer>
  );
};

export default ExportMachine;
